import { render, staticRenderFns } from "./NotificaAsseverazione.vue?vue&type=template&id=114ae4b8&"
import script from "./NotificaAsseverazione.vue?vue&type=script&lang=js&"
export * from "./NotificaAsseverazione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports